const Blank = () => {
  return null;
};

Blank.displayName = 'Blank';
export default Blank;
